const EventEmitter = require('events')
declare global {
  interface Window {
    bridge: any
    app: any
    webkit: any
    opera: any
    MobileApp: any
  }
}
class MobileApp extends EventEmitter {
  constructor() {
    super()
    this.setDeviceInfo(navigator.userAgent || navigator.vendor || window.opera)
    window.bridge = {}
  }
  callAndroidMethod(value: string, name: string) {
    window.app[name](value)
  }
  callIosMethod(value: string, name: string) {
    window.webkit.messageHandlers[name].postMessage(value)
  }

  call(value = 'No Value', name = 'debugMessageLog') {
    if (/iphone|ipod|ipad/i.test(this.deviceInfo)) {
      this.callIosMethod(value, name)
    } else if (/android/i.test(this.deviceInfo)) {
      this.callAndroidMethod(value, name)
    } else {
      console.log('MethodName', name)
      console.log('MethodValue', value)
      return null
    }
  }

  createFunction(name: string, method: string) {
    window.bridge[name] = method
  }

  deleteFunction(name: string) {
    delete window.bridge[name]
  }

  setDeviceInfo(value: string) {
    this.deviceInfo = value
  }
  getDeviceInfo() {
    return this.deviceInfo
  }
}

export default MobileApp
